import useRequest, {
    RequestFn, RequestKeys,
} from 'app/hooks/useRequest'
import AdditionalFeesRequests from 'app/requests/ContractBasis/AdditionalFees.requests'
import {
    AdditionalFeeValue,
} from '../AdditionalFee.types'

export default function useGetAdditionalFeesById(id: number) {
    return useRequest<AdditionalFeeValue>({
        key: RequestKeys.getContractBasisAdditionalFeeDetails,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(AdditionalFeesRequests.get),
        enabled: Boolean(id),
    })
}
